import React, { useEffect, useState } from 'react';
import { Box } from '@ally/metronome-ui';

interface IProps {
  onChange: (value: string) => void;
  defaultValue?: string;
}

interface TabChildProps {
  value: string;
  onClick?: () => void;
  active?: boolean;
}

const TabSelector: React.FC<IProps> = (
  props: React.PropsWithChildren<IProps>
) => {
  const [active, setActive] = useState<string>('');

  useEffect(() => {
    const children = React.Children.toArray(props.children);
    if (React.isValidElement(children[0])) {
      const value = children[0].props.value;
      setActive(value);
    }
    if (props.defaultValue) {
      props.onChange(props.defaultValue);
      setActive(props.defaultValue);
    }
  }, []);

  const selectTab = (value: string) => {
    if (value !== active) {
      setActive(value);
      props.onChange(value);
    }
  };

  const { onChange, ...boxProps } = props;

  return (
    <Box {...boxProps} role='tablist'>
      {React.Children.map(props.children, (child) =>
        React.isValidElement<TabChildProps>(child)
          ? React.cloneElement(child, {
              onClick: () => {
                selectTab(child.props.value);
              },
              active: child.props.value === active,
            })
          : child
      )}
    </Box>
  );
};

interface IProps {
  children?: React.ReactNode;
  onChange: (value: string) => void;
  defaultValue?: string;
}

export default TabSelector;
